<template lang="pug">
  apollo-query(
    :query="query"
    :fetchPolicy="fetchPolicy"
    tag=""
    @result="onResult")
    template(slot-scope="{ result: { loading, error, data } }")
      slot(:supportedDanceKinds="supportedDanceKinds") Implement required
</template>

<script>
import { FETCH_SUPPORTED_DANCE_KINDS_QUERY } from '@/graphql'

export default {
  props: {
    fetchPolicy: { type: String, default: 'cache-first' },
  },
  data() {
    return {
      query: FETCH_SUPPORTED_DANCE_KINDS_QUERY,
      supportedDanceKinds: [],
    }
  },
  methods: {
    onResult(result) {
      this.supportedDanceKinds = Object.freeze(result.data.supportedDanceKinds)
    },
  },
}
</script>
